<template>
    <section class="pageSection">
        <sync-loader class="load-spinner" :loading="(!user || !test)" :size="30" :sizeUnit="'px'"></sync-loader>
        <transition name="fade" mode="out-in" @beforeLeave="beforeLeave" @enter="enter" @afterEnter="afterEnter">
            <div v-if="user && test && !attempPassed" class="section_columns air-lg">
                    <div>
                        <h3>Acceso al test de certificación de ONiAd Academy</h3>
                        <p>
                            <b>Curso: </b> <i>{{test.title}}</i><br>
                            <b>Tiempo para realizar el test: </b><i>{{test.attemp_time_limit_minutes}} minutos</i><br>
                            <b>Mínimo para aprobar: </b><i>{{test.attemp_pass_correct_answers}} respuestas correctas</i><br>
                        </p>
                        <p>Puedes realizar el test las veces que necesites pero no puedes pausar el tiempo. Si el tiempo se agota se enviarán automáticamente las respuestas y se mostrará el resultado.</p>
                        <p>Verás el tiempo restante en la parte superior derecha.</p>
                        <div class="section_columns">
                            <div class="form-vue compact" v-if="user !== null && !user.name || !dataSended">
                                <div class="form-group-vue flex-column">
                                    <p style="font-size: 1.2em">Necesitamos los siguientes datos para emitir el certificado.</p>
                                    <!--                                <p>Necesitamos los datos siguientes para emitir el certificado y poder enviartelo al email</p>-->
                                    <!--                                <p>Siempre podrás volver a ver tu certificado a través de un enlace que te enviaremos.</p>-->
                                </div>
                                <div class="form-group-vue flex-column form-group-vue-horizontal">
                                    <float-label>
                                        <input :placeholder="'Nombre'" v-model="user.name" class="form-control" type="text">
                                    </float-label>
                                    <float-label>
                                        <input :placeholder="'Apellidos'" v-model="user.surname" class="form-control" type="text">
                                    </float-label>
                                </div>
                                <div class="form-group-vue flex-column form-group-vue-horizontal">
                                    <float-label>
                                        <input :placeholder="'Teléfono'" v-model="user.phone" class="form-control" type="text">
                                    </float-label>
                                    <float-label>
                                        <input :placeholder="'Perfil de linkedin(opcional)'"
                                               v-model="user.social.linkedin" class="form-control" type="text">
                                    </float-label>
                                </div>
                                <div class="form-group-vue flex-column">
                                    <float-label :main-label="'Ocupación principal'">
                                        <select v-model="user.occupation.name" class="form-control" required v-on:change="user.occupation.place = ''">
                                            <!--                                <option disabled selected value="">Ocupación principal</option>-->
                                            <option value="estudiante">Estudiante</option>
                                            <option value="empleado">Empleado por cuenta ajena</option>
                                            <option value="freelance">Freelance / Autónomo</option>
                                            <option value="empresario">Empresario</option>
                                        </select>
                                    </float-label>
                                </div>
                                <div class="form-group-vue flex-column" v-show="user.occupation.name === 'estudiante'">
                                    <float-label>
                                        <input :placeholder="'Centro de estudios'" ref="est"
                                               v-model="user.occupation.place" class="form-control" type="text">
                                    </float-label>
                                </div>
                                <div v-show="user.occupation.name !== 'estudiante'" class="form-group-vue flex-column">
                                    <float-label>
                                        <input :placeholder="'Nombre de la empresa'" ref="aje"
                                               v-model="user.occupation.place" class="form-control" type="text">
                                    </float-label>
                                </div>
                                <div class="form-group-vue flex-column form-group-vue-horizontal"
                                     v-if="user.occupation.name !== 'estudiante' && user.occupation.name">
                                    <float-label :main-label="'Sector'">
                                        <select v-model="user.occupation.sector" class="form-control" required>
                                            <option v-for="sector in sectores" :value="sector.value">{{sector.text}}</option>
                                        </select>
                                    </float-label>
                                    <float-label :main-label="'Cargo'">
                                        <select v-model="user.occupation.position" class="form-control" required>
                                            <option v-for="position in positions" :value="position.value">{{position.text}}</option>
                                        </select>
                                    </float-label>
                                </div>
                                <div class="form-group-vue flex-column" v-if="user.occupation.sector === 'otro'">
                                    <float-label>
                                        <input :placeholder="'¿En qué sector trabajas?'"
                                               v-model="newSector" class="form-control" type="text">
                                    </float-label>
                                </div>
                                <!--                            <div class="form-group-vue flex-column"-->
                                <!--                                 v-if="user.occupation.name !== 'estudiante' && user.occupation.name">-->
                                <!--                                <float-label :main-label="'Cargo'">-->
                                <!--                                    <select v-model="user.occupation.position" class="form-control" required>-->
                                <!--                                        <option v-for="position in positions" :value="position.value">{{position.text}}</option>-->
                                <!--                                    </select>-->
                                <!--                                </float-label>-->
                                <!--                            </div>-->
                                <div class="form-group-vue align-left" v-show="errorForm">
                                    <div class="error">Es necesario rellenar todos los datos obligatorios</div>
                                </div>
                                <!--                            <div class="form-group-vue align-left" v-show="acceptedMandatory === true">-->
                                <!--                                <div class="error">Es necesario acceptar los términos y condiciones para acceder al test</div>-->
                                <!--                            </div>-->
                                <div class="form-group-vue">
                                    <button class="btn btn-success btn-lg" @click="sendData()">Empezar el test</button>
                                </div>
                            </div>
                            <div v-else>
                                <div class="buttonStart" >
                                    <button class="btn btn-success btn-lg" @click="startTest()">Empezar el test</button>
                                </div>
                            </div>
                            <div>
                                <img src="../assets/images/ONiAd-Academy-imagen-2.png" alt="">
                            </div>
                        </div>
                    </div>
            </div>
            <div v-else class="section_columns air-lg">
<!--                <div class="test-info">-->
                    <div>
                        <h1>Ya tienes el certificado emitido</h1>
                        <p>Haz click en el botón de debajo para ver certificado</p>
                        <div class="buttonStart">
                            <button class="btn btn-success btn-lg" @click="getCertificate()">Ver certificado</button>
                        </div>
                    </div>
                    <div>
                        <img src="../assets/images/ONiAd-Academy-imagen-2.png" alt="">
                    </div>
<!--                </div>-->

            </div>
        </transition>
    </section>
</template>

<script>
    /* eslint-disable */
    import {mapState} from 'vuex'
    import FloatLabel from "./elements/FloatLabel";
    import {SyncLoader} from '@saeris/vue-spinners';

    const uuidv4 = require('uuid/v4');

    const sectores = [
        {value: 'agricola', text: 'Agrícola'},
        {value: 'alimentacion', text: 'Alimentación y bebidas'},
        {value: 'industria', text: 'Industria'},
        {value: 'logistica', text: 'Logística/transporte'},
        {value: 'inmobiliario', text: 'Inmobiliario'},
        {value: 'moda', text: 'Moda/belleza'},
        {value: 'cultura', text: 'Cultura/entretenimiento'},
        {value: 'comercio', text: 'Comercio/retail'},
        {value: 'automocion', text: 'Automoción'},
        {value: 'marketing', text: 'Marketing y Publicidad'},
        {value: 'turismo', text: 'Turismo/hostelería'},
        {value: 'salud', text: 'Salud'},
        {value: 'deporte', text: 'Deporte'},
        {value: 'educacion', text: 'Educación'},
        {value: 'financiero', text: 'Financiero/seguros'},
        {value: 'admpublica', text: 'Administración pública'},
        {value: 'otro', text: 'Otros'},
    ];
    const positions = [
        {value: 'CEO', text: 'CEO'},
        {value: 'directivo', text: 'Directivo'},
        {value: 'responseable', text: 'Responsable'},
        {value: 'tecnico', text: 'Técnico'},
        {value: 'practicas', text: 'Prácticas'}
    ];
    export default {
        name: 'certificateStart',
        components: {
            FloatLabel,
            SyncLoader
        },
        computed: mapState(['courses', 'user', 'test']),
        data() {
            return {
                loading: false,
                dataSended: false,
                attempPassed: null,
                sectores: sectores.sort((a, b) => (a.text > b.text) ? 1 : ((b.text > a.text) ? -1 : 0)),
                newSector: '',
                positions: positions.sort((a, b) => (a.text > b.text) ? 1 : ((b.text > a.text) ? -1 : 0)),
                errorForm: false,
                acceptedMandatory: null,
                termsAccept: false,
                dispatchValue: false
            }
        },
        mounted() {
            this.loading = true;
            this.$store.dispatch({type: 'getUser', id: this.$route.params.token}).then(() => {
                if (!this.user.name) {
                    this.dataSended = false
                } else {
                    this.dataSended = true
                }
            }).catch(console.error);
            this.$store.dispatch({
                type: 'getTest',
                data: {testId: this.courses[0].id, user: this.$route.params.token}
            })
                .then(() => {
                    //todo: obtener attemps
                    this.getAttemps();

                })
                .catch(console.error);

        },
        methods: {
            getCertificate() {
                this.$router.push({name: 'certificate', params: {idTest: this.courses[0].id, idAttemp: this.attempPassed[0].id}})
            },
            getAttemps() {
                this.$store.dispatch({
                    type: 'getAttemps',
                    data: {test: this.test, user: this.user, status: 'pass'}
                }).then((attemps) => {
                    if (attemps.length) {
                        this.attempPassed = attemps.slice(-1);
                        //todo: test aprobado. Recibirás email con el certificado en this.user.email
                    }
                    this.loading = false;
                })
            },
            sendData() {
                //TODO: send data then this.startTest()
                this.errorForm = false;
                this.acceptedMandatory = false;
                let data = this.user;
                if (data.occupation.sector === 'otro') {
                    data.occupation.sector = this.newSector;
                    if (!data.occupation.sector.length){
                        data.occupation.sector = 'otro';
                        this.errorForm = true;
                        return false;
                    }
                }
                if (
                    !data.name || !data.name.length ||
                    !data.surname || !data.surname.length ||
                    !data.phone || !data.phone.length ||
                    !data.occupation.name || !data.occupation.name.length ||
                    !data.occupation.place || !data.occupation.place
                ) {
                    this.errorForm = true;
                    return false;
                } else {
                    if (data.occupation.name !== 'estudiante') {
                        if (
                            !data.occupation.position ||
                            !data.occupation.position.length ||
                            !data.occupation.sector ||
                            !data.occupation.sector.length
                        ) {
                            this.errorForm = true;
                            return false;
                        }
                    }
                }
                if (!data.social.linkedin || !data.social.linkedin.length) {
                    data.social.linkedin = null;
                }
                this.loading = true;
                this.$store.dispatch({type: 'patchUser', data: data})
                    .then((response) => {
                        this.startTest();
                    })
                    .catch((e) => {
                    })
                    .finally(() => {
                        this.loading = false
                    });
            },
            checkData() {
            },
            startTest() {
                //todo: enviar email con link de attemp passed
                this.$router.push({name: 'test', params: {courseId: this.courses[0].id, token: this.$route.params.token}})
            },
            beforeLeave(element) {
                this.prevHeight = getComputedStyle(element).height;
            },
            enter(element) {
                const {height} = getComputedStyle(element);

                element.style.height = this.prevHeight;

                setTimeout(() => {
                    element.style.height = height;
                });
            },
            afterEnter(element) {
                element.style.height = 'auto';
            },
        }
    }
</script>

<style lang="scss">
    .text-center {
        text-align: center;
    }
    .align-left {
        text-align: left;
    }
    .form-vue.form-half-size{
        width: 50%;
    }
    /*.test-info{*/
    /*    display: flex;*/
    /*    >div{*/
    /*        margin-right: 1em;*/
    /*    }*/
    /*}*/

</style>
